import React, { Component } from 'react'
import Gallery from './gallery'

export default class GalleryThumbnail extends Component {
  render() {
    const { fluids, captions, originals, size } = this.props
    return (
      <div>
        <Gallery
          fluids={fluids}
          captions={captions}
          originals={originals}
          size={size}
        />
      </div>
    )
  }
}
